const generateSliderStyles = require('./generate-slider-styles.js')

const rooster = {
  pill: {
    zIndex: '100',
    position: 'absolute',
    backgroundColor: '#ebebeb',
    height: '40%',
    width: '130px',
    padding: '5px',
    right: 0,
    borderRadius: '500px',
    bottom: '50%',
    transform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  handleContainer: {
    position: 'relative',
    height: '100%',
    left: '-22px',
    width: '860px',
  },
}

const tops = {
  pill: {
    zIndex: '100',
    position: 'absolute',
    background: 'linear-gradient(#63aef8, #1672fb)',
    height: '40%',
    width: '130px',
    padding: '5px',
    right: 0,
    borderRadius: '500px',
    bottom: '50%',
    transform: 'translate(0, 50%)',
    WebkitTransform: 'translate(0, 50%)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: 'white',
  },
  numberLine: {
    position: 'absolute',
    top: 'calc(50%)',
    transform: 'translateY(-25%)',
    left: '0px',
    leftFill: '#555555',
    rightFill: '#929292',
  },
  handleContainer: {
    position: 'relative',
    height: '100%',
    left: '-22px',
    width: '860px',
  },
  hour1: {
    color: '#555555',
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '11px',
    right: '0px',
    bottom: '5px',
    float: 'left',
  },
  hour7: {
    color: '#555555',
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '11px',
    right: '130px',
    bottom: '5px',
    float: 'left',
  },
  day1: {
    color: '#555555',
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '11px',
    right: '180px',
    bottom: '5px',
    float: 'left',
  },
  day15: {
    color: '#555555',
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '11px',
    left: '334px',
    bottom: '5px',
    float: 'left',
  },
  day30: {
    color: '#555555',
    fontWeight: 'bold',
    position: 'absolute',
    fontSize: '11px',
    left: '24px', // lands between -29 & -30 days!
    bottom: '5px',
    float: 'left',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  generateSliderStyles(tops, { timeLabelColor: '#555555', isTops: true, isNegative: true }) :
  generateSliderStyles(rooster, { timeLabelColor: '#8f8f8f', isNegative: true })



// WEBPACK FOOTER //
// ./src/components/Settings/styles/Sliders/NextAppointment.js